import React from 'react';
import { useSelector } from 'react-redux';
// import { useNotification } from '../../providers/NotificationsProvider';

const ProviderGate = ({ provider, children, canSee = true }) => {
  const allProviders = useSelector(({ provider }) => provider.providers);
  // const { notify } = useNotification();
  if (allProviders.includes(provider) && canSee) {
    return children;
  }
  // notify({message: "You don't have permission to access this page!", severity: "error"})
  return <></>;
};

export default ProviderGate;
